import { inject, injectable } from 'inversify';
import {
  installTelemetry,
  InstallOptions,
} from '@gh/grub-telemetry-core-external-bridge';
import { logException, logPageAction } from '@gh/grub-telemetry-core';
import { isProd } from '../../utilities/environment';
import { TYPES } from '../../di/types';
import { Monitor, SLOEvent, TelemetryEventData } from './types';
import { eventBus } from './eventBus';

export interface GrubTelemetryService extends Monitor {
  sendPageActionEvent(data: TelemetryEventData): void;
}

@injectable()
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export class GrubTelemetryServiceImpl implements GrubTelemetryService {
  private startSLOSuffix = '_START';
  private endENDSuffix = '_END';

  constructor(@inject(TYPES.AppConfig) private readonly appConfig: AppConfig) {
    const config: InstallOptions = {
      environment: isProd() ? 'production' : 'preprod',
      appVersion: this.appConfig.version,
      release: this.appConfig.version,
      datadogConfig: appConfig.datadog,
      enableDatadog: true,
      disableNewRelic: true,
    };
    installTelemetry(eventBus, config);
  }

  public reportError(error: Error): void {
    logException(error, eventBus);
  }

  public sendSLOStartingEvent<T extends {}>(sloEvent: SLOEvent<T>): void {
    logPageAction(
      `${sloEvent.name}${this.startSLOSuffix}`,
      eventBus,
      sloEvent.metadata,
    );
  }

  public sendSLOEndingEvent<T extends {}>(sloEvent: SLOEvent<T>): void {
    logPageAction(
      `${sloEvent.name}${this.endENDSuffix}`,
      eventBus,
      sloEvent.metadata,
    );
  }

  public sendPageActionEvent(data: TelemetryEventData): void {
    logPageAction(data.type, eventBus, data.payload);
  }
}
